var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkCancelled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11454 10.8279L7.99988 8.94254L9.88521 10.8279L10.8279 9.88521L8.94254 7.99988L10.8279 6.11454L9.88521 5.17188L7.99988 7.05721L6.11454 5.17188L5.17188 6.11454L7.05721 7.99988L5.17188 9.88521L6.11454 10.8279Z",
    fill: "#495057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0026 14.6654C11.6786 14.6654 14.6693 11.6747 14.6693 7.9987C14.6693 4.3227 11.6786 1.33203 8.0026 1.33203C4.3266 1.33203 1.33594 4.3227 1.33594 7.9987C1.33594 11.6747 4.3266 14.6654 8.0026 14.6654ZM8.0026 2.66536C10.9433 2.66536 13.3359 5.05803 13.3359 7.9987C13.3359 10.9394 10.9433 13.332 8.0026 13.332C5.06194 13.332 2.66927 10.9394 2.66927 7.9987C2.66927 5.05803 5.06194 2.66536 8.0026 2.66536Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkCancelled);
export default __webpack_public_path__ + "static/media/markCancelled.f0b30789adc20d7f73f5f219f241cd45.svg";
export { ForwardRef as ReactComponent };